import angular from 'angular';
import controller from './fileUpload.controller';
import template from './fileUpload.html';
import './fileUpload.scss';
import FileUploadComponent from './fileUpload.component';

const fileUploadConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('fileUpload', {
		title:                  'File (upload only)',
		template,
		group:                  'advanced',
		children:               false,
		selectable:             true,
		settings:               new FileUploadComponent(),
		icon:                   'fa fa-file',
		views:                  [
			{
				name:     'Display',
				template: 'kform/components/fileUpload/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		controller,
	});
};

export default angular.module('app').config(fileUploadConfig);
